import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import LandingPage from "./pages/LandingPage";
import AdminDashboard from "./pages/AdminDashboard";
import TermsConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Accessibility from "./pages/Accessibility";
import Complaints from "./pages/Complaints";
import WithdrawalForm from "./pages/WithdrawalForm";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";
import Shop from "./pages/Shop";
import ShopSuccess from "./pages/ShopSuccess";
import { Toaster } from "./components/ui/sonner";
import CookieBanner from "./components/CookieBanner";

const TOAST_OPTIONS = {
  style: {
    background: '#0A0A0A',
    color: '#FFFFFF',
    border: '1px solid rgba(255, 255, 255, 0.1)',
  },
};

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-black">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="/complaints" element={<Complaints />} />
            <Route path="/withdrawal" element={<WithdrawalForm />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/success" element={<ShopSuccess />} />
          </Routes>
        </BrowserRouter>
        <Toaster 
          position="bottom-right"
          toastOptions={TOAST_OPTIONS}
        />
        <CookieBanner />
      </div>
    </LanguageProvider>
  );
}

export default App;
